import { InquiryResponseDtoType } from '@/api/generated/model';

export const InquiryTxnType = InquiryResponseDtoType;

export type InquiryTxnType = (typeof InquiryTxnType)[keyof typeof InquiryTxnType];

export const INQUIRY_TXN_TYPE_OPTIONS = [
    {
        key: InquiryTxnType.BUY,
        value: 'Kúpa',
        slug: 'kupa',
    },
    {
        // Kontrakt pozna pre dopyt len BUY a RENT - RENT_WANTED neexistuje,
        // takze key bol undefined (chybajuci React key + polozka sa tvarila
        // ako vybrana, ked nebolo vybrane nic). Dopyt na prenajom = RENT.
        key: InquiryTxnType.RENT,
        value: 'Hľadám Prenájom',
        slug: 'hladam-prenajom',
    },
] as const;

export type InquiryTxnTypeOption = (typeof INQUIRY_TXN_TYPE_OPTIONS)[number];
